<router-outlet></router-outlet>
<button style="display: none;" id="auto_trigger" (click)="showModalConfirm()" ></button>
<button style="display: none;" id="finishcall_trigger" (click)="showFinishAlert()"></button>
<button style="display: none;" id="timeout_trigger" (click)="showTimeoutAlert()"></button>
<app-request-error></app-request-error>